// Generated from products/analytics/shared/domainConfig.ts; run analytics generate:site-runtime.
import { z } from "zod";

/** Canonical DNS hostname, without a scheme, port, trailing dot or URL components. */
export const AnalyticsHostnameSchema = z.string().min(1).max(253).regex(
  /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)*[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/,
).refine((value) => {
  try { return new URL(`https://${value}`).hostname === value; }
  catch { return false; }
});
export const AnalyticsCollectionPathSchema = z.string().regex(/^\/[A-Za-z0-9_-]{16}$/);

/** Only a public 2048-bit RSA-OAEP/SHA-256 key; private parameters are rejected. */
export const AnalyticsPublicKeySchema = z.strictObject({
  kty: z.literal("RSA"),
  alg: z.literal("RSA-OAEP-256"),
  // 256-byte unsigned modulus, high bit set, odd, with canonical Base64URL tail bits.
  n: z.string().regex(/^[g-z0-9_-][A-Za-z0-9_-]{340}[Qw]$/),
  e: z.literal("AQAB"),
  ext: z.literal(true).optional(),
  key_ops: z.tuple([z.literal("encrypt")]).optional(),
});

export const BrowserAnalyticsConfigSchema = z.strictObject({
  schemaVersion: z.literal(1),
  hostname: AnalyticsHostnameSchema,
  path: AnalyticsCollectionPathSchema,
  publicKey: AnalyticsPublicKeySchema,
});
export const AnalyticsDomainConfigSchema = BrowserAnalyticsConfigSchema.extend({
  projectId: z.uuid(),
  domainId: z.uuid(),
  environment: z.enum(["dev", "production"]),
});
export type AnalyticsDomainConfig = z.infer<typeof AnalyticsDomainConfigSchema>;
export type BrowserAnalyticsConfig = z.infer<typeof BrowserAnalyticsConfigSchema>;

export function toBrowserAnalyticsConfig(full: AnalyticsDomainConfig): BrowserAnalyticsConfig {
  const { schemaVersion, hostname, path, publicKey } = AnalyticsDomainConfigSchema.parse(full);
  return BrowserAnalyticsConfigSchema.parse({ schemaVersion, hostname, path, publicKey });
}
